import {createRouter, createWebHistory} from 'vue-router'
import MainLayout from "@/layouts/MainLayout.vue";
import NotFoundView from "@/views/NotFoundView.vue";
import {inject} from "vue";
import {requestHttp} from "@/services/HttpRequest";

const routes = [
    {
        path: '/home',
        name: 'mainLayout',
        component: MainLayout,
        children: [
            {
                path: '/home',
                name: 'home',
                component: () => import(/* webpackChunkName: "about" */ '../views/HomeView.vue')
            },
            {
                path: '/redeem',
                name: 'redeem',
                component: () => import(/* webpackChunkName: "about" */ '../views/RedeemView.vue')
            },
            {
                path: '/',
                name: 'landing',
                component: () => import(/* webpackChunkName: "about" */ '../views/Landing.vue')
            },
            {
                path: '/ranking',
                name: 'ranking',
                component: () => import(/* webpackChunkName: "about" */ '../views/RankingView.vue')
            },
            {
                path: '/storeKeeperRanking',
                name: 'storeKeeperRanking',
                component: () => import(/* webpackChunkName: "about" */ '../views/StorekeeperRankingView.vue')
            },
            {
                path: '/consumidor',
                name: 'consumidor',
                component: () => import(/* webpackChunkName: "about" */ '../views/ConsumerView.vue')
            },
            {
                path: '/tiendas-participantes',
                name: 'tiendas',
                component: () => import(/* webpackChunkName: "about" */ '../views/TiendasView.vue')
            },
        ],
    },
    {
        path: '/register',
        name: 'register',
        component: () => import(/* webpackChunkName: "about" */ '../views/RegistroView.vue')
    },
    {
        path: '/map',
        name: 'map',
        component: () => import(/* webpackChunkName: "about" */ '../components/Map/MapComponent.vue')
    },
    {
        path: '/home-consumidor',
        name: 'home-consumidor',
        component: () => import(/* webpackChunkName: "about" */ '../views/HomeConsumidor.vue')
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'notFound',
        component: NotFoundView
    },
    {
        path: '/user-register',
        name: 'user-register',
        component: () => import(/* webpackChunkName: "about" */ '../views/UserRegisterView.vue')
    },
    {path: '/:pathMatch(.*)*', name: 'notFount', component: NotFoundView},
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

router.beforeEach(async (to, from, next) => {
    const rootScope = inject('rootScope')

    if (to.query.token) {
        console.log(to.query)
        const token = to.query.token;
        localStorage.setItem('token', token);
        console.log('Token encontrado en URL y guardado:', token);

        if (to.query.id) {
            rootScope.reference_id = to.query.id;
            rootScope.whatsapp = true;
        }

        if (to.query.nid) {
            //console.log('Negocio_id: ', to.query.nid);
            rootScope.negocio_id = to.query.nid;
        }

        if (to.name === 'home') {
            next({name: 'home', query: {}});
            return;
        }

        if (to.name === 'redeem') {
            next({name: 'redeem', query: {}});
            return;
        }
    }

    // Validar sesión con el token que ya está en localStorage
    try {
        rootScope.loading = true;
        const response = await requestHttp({
            endpoint: "auth/authStatus",
        });

        rootScope.loading = false;
        const data = response.data;

        if (data.estado === 400) {
            rootScope.logged = false;
            rootScope.name = "";
            rootScope.user = 0;

            // 'home' agregado a las rutas que no redirigen a landing porque el usuario viene desde WhatsApp con token válido

            if (
                to.name !== 'login' &&
                to.name !== 'register' &&
                to.name !== 'forgot-password' &&
                to.name !== 'landing' &&
                to.name !== 'map' &&
                to.name !== 'home-consumidor' &&
                to.name !== 'user-register' &&
                to.name !== 'consumidor' &&
                to.name !== 'tiendas' &&
                to.name !== 'home'  // <- AGREGADO
            ) {
                next({name: 'landing'});
            } else {
                next();
            }

        } else if (data.estado === 200) {

            const datosSession = data.data;
            rootScope.logged = datosSession.logueado;
            rootScope.name = datosSession.nombre;
            rootScope.userId = datosSession.usuario;
            rootScope.region = datosSession.region;
            rootScope.perfilId = datosSession.perfil;
            rootScope.celular = datosSession.celular;

            if (to.name === 'tiendas' || to.name === 'home' || to.name === 'redeem') {
                next();
            } else if (rootScope.perfilId === 5 && to.name !== 'storeKeeperRanking') {
                next({name: 'storeKeeperRanking'});
            } else if (rootScope.perfilId === 2 && to.name !== 'ranking') {
                next({name: 'ranking'});
            } else {
                next();
            }

        } else {
            rootScope.logged = false;
            next({name: 'login'});
        }

    } catch (error) {
        rootScope.logged = false;
        rootScope.loading = false;
        next({name: 'login'});
    }
});

export default router